export default __webpack_public_path__ + "static/media/office1-after2-1024w.9161b139.webp";